export const selectBasketItems = (state) => state.dataDictionaryBasket.items;

export const selectBasketCount = (state) => state.dataDictionaryBasket.items.length;

export const selectIsInBasket = (state, columnKey) =>
    state.dataDictionaryBasket.items.some((i) => i.columnKey === columnKey);
